import React, { ReactElement } from 'react'
import { Flex, Text } from 'theme-ui'
import { Svg } from 'ui'
import PikaManIcon from 'images/homePage/pikaman.svg'
import GetStartedButton from './GetStartedButton'

interface TakeBackYourInternetSectionProps {
  featuredProfile?: string
}

const TakeBackYourInternetSection = ({
  featuredProfile,
}: TakeBackYourInternetSectionProps): ReactElement => {
  return (
    <Flex
      sx={{
        my: ['4rem', '4.8rem'],
        flexDirection: ['column', 'row'],
        alignItems: 'center',
        textAlign: ['center', 'left'],
        justifyContent: 'center',
      }}
    >
      <Svg
        svg={PikaManIcon}
        sx={{
          mr: [0, '4.8rem'],
          mb: ['2.4rem', 0],
          width: ['14.8rem', '24rem'],
          height: ['14.8rem', '24rem'],
        }}
        descriptiveText="Take back your internet hero illustration"
      />
      <Flex
        sx={{
          flexDirection: ['column', 'column', 'row'],
          alignItems: ['center', 'left', 'center'],
        }}
      >
        <Text
          as="h2"
          sx={{
            mr: [0, '8.6rem'],
            fontSize: ['2.8rem', '4.8rem'],
            fontWeight: 'bold',
            width: ['25.6rem', '38.9rem'],
            mb: ['2.4rem', '4.8rem', 0],
            alignSelf: ['center', 'left'],
            lineHeight: '1.29',
          }}
        >
          Take back your internet.
        </Text>
        <GetStartedButton featuredProfile={featuredProfile} />
      </Flex>
    </Flex>
  )
}

export default TakeBackYourInternetSection
